<div class="section" id="section">

  @if (viewEventi){
    <div class="big-button" (click)="goToUrl(event_url)">
      <div class="img-button">
        <mat-icon svgIcon="event-home" aria-hidden="false"></mat-icon>
      </div>
      <div class="label-box">
        <h3>Gestione Eventi</h3>
      </div>
    </div>
  }

  @if (viewReservation){
    <div class="big-button"  (click)="goToUrl(reservation_url)">
      <div class="img-button">
        <mat-icon svgIcon="reservation-home" aria-hidden="false"></mat-icon>
      </div>
      <div class="label-box">
        <h3>Gestione Prenotazioni</h3>
      </div>
    </div>
  }

  @if (viewMdr){
    <div class="big-button" (click)="goToUrl(mdr_url)">
      <div class="img-button">
        <mat-icon svgIcon="restaurant-home" aria-hidden="false"></mat-icon>
      </div>
      <div class="label-box">
        <h3>Gestione Ristoranti e cambio turni</h3>
      </div>
    </div>
  }

</div>
